/**
 * Combines all the modules into one module. The injected modules can specify their own dependent modules
 */
angular.module('AppCtrl', [
    'ngRoute',
    'App.video.routes',
    'App.video.service',
    'App.video.rootscope',
    'jv.Common.Timer',
    'jv.Common.Directives.VideoRecorder',
    'jv.Common.Directives.VonageVideoRecorder',
    'jv.Common.Directives.VideoPlayer',
    'jv.Common.Directives.PageRefresh',
    'jv.jobseeker.playbackVideo',
    'App.video.staleVideo',
    'jv.Common.Modal',
    'jv.Common.Jobvite.Urls',
    'jv.log4javascript',
    'jv.Common.i18n',
    'jv.video.request.extension.controller',
    'jv.video.interviewee.question.controller'
])
    .value('modalTemplateUrl', 'modalTemplate.html')
    // .value('messageBarTemplateUrl', 'messageBar.html')
    .factory('errorInterceptor', ['$location', '$window', '$jobviteUrls',
        function($location, $window, $jobviteUrls) {
            return function(promise) {

                /**
                 * Check for any errors that can occur and redirect the user to the proper page.
                 * @param {Object} result
                 */
                function checkAndRedirectForErrors(result) {
                    if (result.data.error) {
                        switch (result.data.error) {
                            case 400:
                                //$location.path('/Review/invalid');
                                $window.location.href = $jobviteUrls.video + '/video/jobseeker/jobseekerListview.html';
                                break;
                        }
                        return true;
                    }
                    return result;
                }

                return promise.then(function(response) {
                    return checkAndRedirectForErrors(response);
                }, function(response) {
                    //$location.path('/Review/invalid');
                    $window.location.href = $jobviteUrls.video + '/video/jobseeker/jobseekerListview.html';
                });
            };
        }
    ])
    .config(['$httpProvider', '$locationProvider',
        function($httpProvider, $locationProvider) {
            $httpProvider.interceptors.push('errorInterceptor');
            $locationProvider.hashPrefix('');
        }
    ]);
